/**
 * Lightweight shared primitives used by every directory compliance widget.
 * Keeps the per-widget files focused on their own logic and reduces drift.
 */
import React from 'react';
import { Badge } from './ui/badge';
import { CheckCircle, AlertTriangle, ShieldAlert, Info } from 'lucide-react';

export const STATUS_BADGE = {
  // Internal statuses returned by classifiers
  passed: { className: 'bg-emerald-100 text-emerald-800 border-emerald-200', label: 'Passed', icon: CheckCircle },
  pass: { className: 'bg-emerald-100 text-emerald-800 border-emerald-200', label: 'Passed', icon: CheckCircle },
  insufficient_evidence: { className: 'bg-amber-100 text-amber-800 border-amber-200', label: 'Needs review', icon: AlertTriangle },
  failed: { className: 'bg-red-100 text-red-800 border-red-200', label: 'Failed', icon: ShieldAlert },
  fail: { className: 'bg-red-100 text-red-800 border-red-200', label: 'Failed', icon: ShieldAlert },
  not_applicable: { className: 'bg-slate-100 text-slate-700 border-slate-200', label: 'N/A', icon: Info },
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_BADGE[status] || STATUS_BADGE.not_applicable;
  const Icon = meta.icon;
  return (
    <Badge className={`${meta.className} inline-flex items-center gap-1`} data-testid={`status-badge-${status}`}>
      <Icon className="w-3 h-3" />
      {meta.label}
    </Badge>
  );
};

export const FrameworkLine = ({ children }) => (
  <p className="text-xs text-slate-500 mt-1">{children}</p>
);

export const NextStepsBox = ({ text }) => (
  text ? (
    <div className="text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md p-3">
      <span className="font-medium text-slate-700">Next steps:</span> {text}
    </div>
  ) : null
);
